module.exports = __webpack_public_path__ + "5b3271e7961d62b5bb8bb8667d9930e3.svg";